<mat-form-field [ngClass]="field_class" [formGroup]="parentForm">
  <mat-select [formControlName]="'Cylinders'" name="Cylinders" placeholder="Cylinders" [multiple]="isMultiple"
    [attr.disabled]="isLoading" (selectionChange)="selectionChange($event.value)" [(value)]="selectedCylinders">
    <app-select-check-all *ngIf="isMultiple" [form]="parentForm.controls.Cylinders" [values]="cylindersList" (checkAll)="checkAll($event)"></app-select-check-all>
    <mat-option *ngIf="!isMultiple" [value]="'All'">All</mat-option>
    <mat-option *ngFor="let cylinderObj of cylindersList" [value]="cylinderObj.filter">{{cylinderObj.filter}}</mat-option>
  </mat-select>
  <mat-error *ngIf="parentForm.controls.Cylinders.invalid && (parentForm.controls.Cylinders.dirty || parentForm.controls.Cylinders.touched)">
    <span *ngIf="parentForm.controls.Cylinders.errors.required || parentForm.controls.Cylinders.errors.Cylinders">
      Please choose Cylinders
    </span>
    <span *ngIf="formError?.Cylinders">{{formError.Cylinders}}</span>
  </mat-error>
</mat-form-field>
